export const ACTIVITIES = [
  { key: 'all' },
  { key: 'album' },
  { key: 'offline' },
  { key: 'ADs' },
  { key: 'misc' },
  { key: 'content' }
];
